// useMapInteraction.js
import { ref, watch, onUnmounted, computed } from 'vue';

export function useMapListeners(map) {
    const isInteracting = ref(false); // Reactive variable to track user interaction
    const mapCenter = ref(false); // Reactive variable to track user interaction

    const startInteraction = () => {
        isInteracting.value = true;
    };

    const endInteraction = () => {
        isInteracting.value = false;
    };

    // Watch the map ref to wait until the map is ready
    watch(map, (newMapInstance) => {
        if (newMapInstance) {
            // Map is ready, add event listeners
            newMapInstance.addListener('mousedown', startInteraction);
            newMapInstance.addListener('mouseup', endInteraction);
            newMapInstance.addListener('dragstart', startInteraction);
            newMapInstance.addListener('dragend', endInteraction);
            newMapInstance.addListener('touchstart', startInteraction);
            newMapInstance.addListener('touchend', endInteraction);

            // Add listener for center_changed to update centered location
            newMapInstance.addListener('center_changed', (e) => {
                mapCenter.value = newMapInstance.getCenter(); // Update reactive variable
            });
        }
    });

    onUnmounted(() => {
        if (map.value) {
            // Clean up event listeners when component unmounts
            google.maps.event.clearListeners(map.value, 'mousedown');
            google.maps.event.clearListeners(map.value, 'mouseup');
            google.maps.event.clearListeners(map.value, 'dragstart');
            google.maps.event.clearListeners(map.value, 'dragend');
            google.maps.event.clearListeners(map.value, 'touchstart');
            google.maps.event.clearListeners(map.value, 'touchend');
        }
    });

    return {
        isInteracting,
        mapCenter, // Return the reactive variable
    };
}
